import { Component } from "@angular/core";

@Component({
    selector: 'icon-mic[ui-kit]',
    template: `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 1.5a2.5 2.5 0 0 0-2.5 2.5v5a2.5 2.5 0 0 0 5 0V4A2.5 2.5 0 0 0 10 1.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.5 9v.5a5.5 5.5 0 0 0 11 0V9M10 15.5v3M7.5 18.5h5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `,
})
export class IconMic {}
